import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import useAllergyList from './hooks';
import { useAllergy } from '../create/hooks';
import { useAppSelector } from '../../../redux/hooks';

import AllergyComponent from './component';
import { IAllergy } from './types';

const Allergy: React.FC = () => {
  const navigate = useNavigate();

  const [isAddModalOpen, setIsAddModalOpen] = useState<boolean>(false);
  const [isConfirmDeleteModalOpen, setIsConfirmDeleteModalOpen] =
    useState<boolean>(false);
  const [selectedAllergy, setSelectedAllergy] = useState<IAllergy | null>(null);

  const currentUser = useAppSelector((state) => state.auth.currentUser);

  const { updatePatientAllergy } = useAllergy(currentUser?.id);
  const { allergies } = useAllergyList({ id: currentUser?.id });

  const goToTasks = () => navigate('/tasks');
  const toggleAddModal = () => setIsAddModalOpen(!isAddModalOpen);
  const toggleDeleteModal = () =>
    setIsConfirmDeleteModalOpen(!isConfirmDeleteModalOpen);

  const handleDeleteAllergy = () => {
    console.log('Selected Allergy:', selectedAllergy, currentUser);

    if (selectedAllergy && currentUser) {
      const { id, name, level, duration_type, duration_value } =
        selectedAllergy;
      updatePatientAllergy({
        id,
        name,
        level,
        durationType: duration_type,
        durationValue: duration_value,
        hospitalId: currentUser.hospitalId,
        _destroy: true,
      });

      toggleDeleteModal();
    }
  };

  return (
    <AllergyComponent
      isModalOpen={isAddModalOpen}
      isDeleteModalOpen={isConfirmDeleteModalOpen}
      allergies={allergies}
      setIsAddModalOpen={setIsAddModalOpen}
      toggleAddModal={toggleAddModal}
      toggleDeleteModal={toggleDeleteModal}
      setSelectedAllergy={setSelectedAllergy}
      handleDeleteAllergy={handleDeleteAllergy}
      navigateToTasks={goToTasks}
    />
  );
};

export default Allergy;
